module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_6000.2da99960.png";